/**
 * Staff area base path (ADMIN_PATH on the server). The server writes it only into the admin shell as
 * `<meta name="iz-admin-path">`; public pages and SSR never see it, so their route tree has no admin routes.
 */
export function adminBasePath(): string | null {
  if (typeof document === 'undefined') return null;
  return document.querySelector<HTMLMetaElement>('meta[name="iz-admin-path"]')?.content || null;
}

/** Panel and login URLs for the staff pages (only routed when the base is present). */
export function adminPaths(): { panel: string; login: string } {
  const base = adminBasePath() ?? '';
  return { panel: base || '/', login: `${base}/login` };
}
